/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddAttachmentToTicketV1Dto } from '../models/AddAttachmentToTicketV1Dto';
import type { AddEmailToTicketV1Dto } from '../models/AddEmailToTicketV1Dto';
import type { BatchManyResultV1Dto } from '../models/BatchManyResultV1Dto';
import type { BrevoCreateSmtpEmailV1Dto } from '../models/BrevoCreateSmtpEmailV1Dto';
import type { CreateTicketFromDocumentV1Dto } from '../models/CreateTicketFromDocumentV1Dto';
import type { CreateTicketFromEMailV1Dto } from '../models/CreateTicketFromEMailV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { MarkNotificationsReadV1Dto } from '../models/MarkNotificationsReadV1Dto';
import type { NextStepV1Dto } from '../models/NextStepV1Dto';
import type { OrderByPropertyDto } from '../models/OrderByPropertyDto';
import type { OrderByRelationalPropertyDto } from '../models/OrderByRelationalPropertyDto';
import type { PatchTicketV1Dto } from '../models/PatchTicketV1Dto';
import type { ProcessStepV1Dto } from '../models/ProcessStepV1Dto';
import type { RequestSignatureV1Dto } from '../models/RequestSignatureV1Dto';
import type { TicketBrevoSendFreeTextPayloadV1Dto } from '../models/TicketBrevoSendFreeTextPayloadV1Dto';
import type { TicketBrevoSendTemplatePayloadV1Dto } from '../models/TicketBrevoSendTemplatePayloadV1Dto';
import type { TicketCommentCreateV1Dto } from '../models/TicketCommentCreateV1Dto';
import type { TicketCommentPatchV1Dto } from '../models/TicketCommentPatchV1Dto';
import type { TicketCommentV1Dto } from '../models/TicketCommentV1Dto';
import type { TicketDetailV2Dto } from '../models/TicketDetailV2Dto';
import type { TicketFilterInnerV2Dto } from '../models/TicketFilterInnerV2Dto';
import type { TicketListPaginatedV2Dto } from '../models/TicketListPaginatedV2Dto';
import type { TicketNotificationV1Dto } from '../models/TicketNotificationV1Dto';
import type { TicketSimplePaginatedV2Dto } from '../models/TicketSimplePaginatedV2Dto';
import type { TicketStatusAlert } from '../models/TicketStatusAlert';
import type { TicketV1Dto } from '../models/TicketV1Dto';
import type { YouSignSignatureWithRequestResponseV1Dto } from '../models/YouSignSignatureWithRequestResponseV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TicketsService {
  /**
   * @deprecated
   * @returns TicketV1Dto a entity list
   * @throws ApiError
   */
  public static ticketControllerV1FindAllV1(): CancelablePromise<Array<TicketV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/tickets',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @deprecated
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static ticketControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/tickets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @returns TicketV1Dto the entity
   * @throws ApiError
   */
  public static ticketControllerV1FindOneV1(uuid: string): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/tickets/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @param requestBody
   * @returns TicketV1Dto the update entity
   * @throws ApiError
   */
  public static ticketControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchTicketV1Dto,
  ): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/tickets/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @deprecated
   * @param uuid ticketId
   * @returns TicketV1Dto the entity
   * @throws ApiError
   */
  public static ticketControllerV1RemoveOneV1(uuid: string): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/tickets/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param ticketNumber ticketNumber
   * @returns TicketV1Dto the entity
   * @throws ApiError
   */
  public static ticketControllerV1FindOneByTicketNumberV1(
    ticketNumber: string,
  ): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/tickets/ticket-number/{ticketNumber}',
      path: {
        ticketNumber: ticketNumber,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @param requestBody
   * @returns BrevoCreateSmtpEmailV1Dto create entity
   * @throws ApiError
   */
  public static ticketControllerV1SendFreeTextEmailV1(
    uuid: string,
    requestBody: TicketBrevoSendFreeTextPayloadV1Dto,
  ): CancelablePromise<BrevoCreateSmtpEmailV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{uuid}/brevo/free-text',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @param requestBody
   * @returns BrevoCreateSmtpEmailV1Dto create entity
   * @throws ApiError
   */
  public static ticketControllerV1SendTemplateEmailV1(
    uuid: string,
    requestBody: TicketBrevoSendTemplatePayloadV1Dto,
  ): CancelablePromise<BrevoCreateSmtpEmailV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{uuid}/brevo/template',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param emailUuid emailId
   * @param requestBody
   * @returns TicketV1Dto create entity
   * @throws ApiError
   */
  public static ticketControllerV1CreateFromEmailV1(
    emailUuid: string,
    requestBody: CreateTicketFromEMailV1Dto,
  ): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/from-email/{emailUuid}',
      path: {
        emailUuid: emailUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @param emailUuid emailId
   * @param requestBody
   * @returns TicketV1Dto create entity
   * @throws ApiError
   */
  public static ticketControllerV1AddEmailToTicketV1(
    uuid: string,
    emailUuid: string,
    requestBody: AddEmailToTicketV1Dto,
  ): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{uuid}/from-email/{emailUuid}',
      path: {
        uuid: uuid,
        emailUuid: emailUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param attachmentUuid attachmentId
   * @param requestBody
   * @returns TicketV1Dto create entity
   * @throws ApiError
   */
  public static ticketControllerV1CreateFromAttachmentV1(
    attachmentUuid: string,
    requestBody: CreateTicketFromDocumentV1Dto,
  ): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/from-attachment/{attachmentUuid}',
      path: {
        attachmentUuid: attachmentUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @param attachmentUuid attachmentId
   * @param requestBody
   * @returns TicketV1Dto create entity
   * @throws ApiError
   */
  public static ticketControllerV1AddAttachmentToTicketV1(
    uuid: string,
    attachmentUuid: string,
    requestBody: AddAttachmentToTicketV1Dto,
  ): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{uuid}/from-attachment/{attachmentUuid}',
      path: {
        uuid: uuid,
        attachmentUuid: attachmentUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @param requestBody
   * @returns YouSignSignatureWithRequestResponseV1Dto create entity
   * @throws ApiError
   */
  public static ticketControllerV1InitiateDocumentSignatureRequestV1(
    uuid: string,
    requestBody: RequestSignatureV1Dto,
  ): CancelablePromise<YouSignSignatureWithRequestResponseV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{uuid}/initiate-document-signature-request',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param orderBy Array of TicketV2Dto order by properties (supports relations with dot-notation)
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying Tickets
   * @param searchString A search string to filter TicketV2Dto by given values.
   * @param statusAlert Ticket status alert
   * @param customerGroupId Customer group ID to filter tickets by
   * @param customerId Customer ID to filter tickets by
   * @returns TicketListPaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static ticketControllerV2FindAllV2(
    orderBy?: Array<OrderByRelationalPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: TicketFilterInnerV2Dto | null,
    searchString?: string | null,
    statusAlert?: TicketStatusAlert,
    customerGroupId?: string,
    customerId?: string,
  ): CancelablePromise<TicketListPaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/tickets',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        statusAlert: statusAlert,
        customerGroupId: customerGroupId,
        customerId: customerId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static ticketControllerV2RemoveManyV2(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/tickets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param orderBy Array of TicketSimpleV2Dto order by properties
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param searchString A search string to filter TicketSimpleV2Dto by given values.
   * @returns TicketSimplePaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static ticketControllerV2FindAllSimplifiedV2(
    orderBy?: Array<OrderByPropertyDto> | null,
    page?: number,
    limit?: number,
    searchString?: string | null,
  ): CancelablePromise<TicketSimplePaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/tickets/simple',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        searchString: searchString,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static ticketControllerV2GetAllTeamNamesV2(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/tickets/teams',
    });
  }
  /**
   * @param uuid ticketId
   * @returns TicketDetailV2Dto the entity
   * @throws ApiError
   */
  public static ticketControllerV2RemoveOneV2(uuid: string): CancelablePromise<TicketDetailV2Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/tickets/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param ticketId
   * @param requestBody
   * @returns TicketCommentV1Dto create entity
   * @throws ApiError
   */
  public static ticketCommentControllerV1CreateCommentV1(
    ticketId: string,
    requestBody: TicketCommentCreateV1Dto,
  ): CancelablePromise<TicketCommentV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{ticketId}/comment',
      path: {
        ticketId: ticketId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param ticketId
   * @param processStepName
   * @returns TicketCommentV1Dto a entity list
   * @throws ApiError
   */
  public static ticketCommentControllerV1FindManyCommentsV1(
    ticketId: string,
    processStepName?: string,
  ): CancelablePromise<Array<TicketCommentV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/tickets/{ticketId}/comment',
      path: {
        ticketId: ticketId,
      },
      query: {
        processStepName: processStepName,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param ticketId
   * @param commentId
   * @param requestBody
   * @returns TicketCommentV1Dto the update entity
   * @throws ApiError
   */
  public static ticketCommentControllerV1UpdatePartialCommentV1(
    ticketId: string,
    commentId: string,
    requestBody: TicketCommentPatchV1Dto,
  ): CancelablePromise<TicketCommentV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/tickets/{ticketId}/comment/{commentId}',
      path: {
        ticketId: ticketId,
        commentId: commentId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param ticketId The ID of the ticket to filter notifications for.
   * @param unreadOnly Filter to show only unread notifications.
   * @returns TicketNotificationV1Dto a entity list
   * @throws ApiError
   */
  public static ticketNotificationControllerV1FindAllNotificationsV1(
    ticketId: string,
    unreadOnly: boolean = false,
  ): CancelablePromise<Array<TicketNotificationV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/tickets/{ticketId}/notifications',
      path: {
        ticketId: ticketId,
      },
      query: {
        unreadOnly: unreadOnly,
      },
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param ticketId The ID of the ticket to filter notifications for.
   * @returns BatchManyResultV1Dto Count of unread notifications of the ticket.
   * @throws ApiError
   */
  public static ticketNotificationControllerV1CountUnreadNotificationsV1(
    ticketId: string,
  ): CancelablePromise<BatchManyResultV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/tickets/{ticketId}/notifications/unread/count',
      path: {
        ticketId: ticketId,
      },
    });
  }
  /**
   * @param ticketId The ID of the ticket to filter notifications for.
   * @param requestBody
   * @returns BatchManyResultV1Dto Number of notifications marked as read
   * @throws ApiError
   */
  public static ticketNotificationControllerV1MarkNotificationsAsReadV1(
    ticketId: string,
    requestBody: MarkNotificationsReadV1Dto,
  ): CancelablePromise<BatchManyResultV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{ticketId}/notifications/mark-read',
      path: {
        ticketId: ticketId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param ticketId The ID of the ticket to filter notifications for.
   * @returns BatchManyResultV1Dto Number of notifications marked as unread
   * @throws ApiError
   */
  public static ticketNotificationControllerV1MarkNotificationsAsUnreadByUserV1(
    ticketId: string,
  ): CancelablePromise<BatchManyResultV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{ticketId}/notifications/mark-unread',
      path: {
        ticketId: ticketId,
      },
    });
  }
  /**
   * @param ticketId The ID of the ticket to filter notifications for.
   * @param requestBody
   * @returns BatchManyResultV1Dto Number of notifications marked as unread
   * @throws ApiError
   */
  public static ticketNotificationControllerV1MarkAllNotificationsAsUnreadV1(
    ticketId: string,
    requestBody: MarkNotificationsReadV1Dto,
  ): CancelablePromise<BatchManyResultV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/{ticketId}/notifications/mark-all-unread',
      path: {
        ticketId: ticketId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param uuid ticketId
   * @returns ProcessStepV1Dto the entity
   * @throws ApiError
   */
  public static processTicketControllerV1FindCurrentStepV1(
    uuid: string,
  ): CancelablePromise<ProcessStepV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/tickets/current-step/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid ticketId
   * @param requestBody The next step to transition to
   * @returns TicketV1Dto the update entity
   * @throws ApiError
   */
  public static processTicketControllerV1TransitionStepV1(
    uuid: string,
    requestBody: NextStepV1Dto,
  ): CancelablePromise<TicketV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/tickets/transition/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
